export const BRAND_NAME = 'NoMoreMissedCalls';
export const BRAND_LOGO_SRC = '/logo.png';
